import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation grantAdminMutation($input: GrantAdminInput!) {
    grantAdmin(input: $input) {
      adminEdge {
        node {
          ...AdminCell_user
        }
      }
      lists {
        ...AdminList_lists
      }
      errors {
        key
        messages
      }
    }
  }
`;

const grantAdmin = (environment, email, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: { email },
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'adminEdge',
        connectionInfo: [
          {
            key: 'AdminList_adminUsers',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default grantAdmin;
